import styled from "@emotion/styled";
import { Box } from "@mui/material";
import type { UserListItemDto } from "Infrastructure/Api/Api";
import { BlDataTable } from "Shared/DataTable/BlDataTable";
import { useUsersQuery } from "Users/Api/Queries/useUsersQuery";

const StyledCell = styled(Box)``;

type Props = {};

export const UsersTable: React.FunctionComponent<Props> = () => {
	const { data, isLoading } = useUsersQuery();

	const users: UserListItemDto[] = data?.items ?? [];

	return (
		<>
			<BlDataTable
				rows={users.map((x) => ({ data: x }))}
				rowEntityID="userID"
				isLoading={isLoading}
				getHeaderCell={(column) => <div>{column.label ?? column.id}</div>}
				columns={[
					{ id: "firstName", label: "First Name" },
					{ id: "lastName", label: "Last Name" },
					{ id: "login", label: "Login" },
					{ id: "tenantCode", label: "Tenant" },
					{ id: "dateCreated", label: "Date Created" },
				]}
				rowsPerPage={10}
				getCell={(id, data) => {
					switch (id) {
						case "firstName":
							return <StyledCell>{data.firstName}</StyledCell>;
						case "lastName":
							return <StyledCell>{data.lastName}</StyledCell>;
						case "login":
							return <StyledCell>{data.login}</StyledCell>;
						case "tenantCode":
							return <StyledCell>{data.tenantCode}</StyledCell>;
						case "dateCreated":
							return (
								<StyledCell>
									{new Date(data.dateCreated).toLocaleDateString()}
								</StyledCell>
							);
						default:
							return <StyledCell></StyledCell>;
					}
				}}
			/>
		</>
	);
};
